/*
 * @Author: wanghongjun
 * @Date: 2025-02-19 09:25:56
 * @LastEditors: wanghongjun
 * @LastEditTime: 2025-02-19 16:51:01
 * @FilePath: /banliucheng-h5/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
// import RegisterEntry_tl4 from "@/views/registerEntry_tl4.vue";
import utils from "@/utils/";
const { qs } = utils;
import { setItem } from "@/utils/storage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/half",
    name: "home",
    meta: {
      title: "臻享用",
    },
    component: HomeView,
  },
  // {
  //   path: "/form",
  //   name: "form",
  //   meta: {
  //     title: "臻享花",
  //   },
  //   component: RegisterEntry_tl4,
  // },
  {
    path: "/result",
    name: "result",
    meta: {
      title: "申请结果",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ResultView.vue"),
  },
  {
    path: "/list",
    name: "list",
    meta: {
      title: "借款优选",
    },
    component: () => import("../views/ListView.vue"),
  },
  {
    path: "/regist",
    name: "regist",
    meta: { title: "登录" },
    component: () => import("../views/RegistView.vue"),
  },
  {
    path: "/leads",
    name: "leads",
    meta: { title: "申请额度" },
    component: () => import("../views/LeadsView.vue"),
  },
  {
    path: "/loading",
    name: "loading",
    meta: { title: "评估中" },
    component: () => import("../views/LoadingView.vue"),
  },
  {
    path: "/download",
    name: "download",
    meta: { title: "下载" },
    component: () => import("../views/DownloadView.vue"),
  },
];

const router = new VueRouter({
  routes,
});
// 中间件
router.beforeEach((to, from, next) => {
  // 设置页面的title
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title;
  }
  const query = qs();
  if (query && query.token) {
    setItem("token", query.token);
  }
  if (query && query.channel_code) {
    setItem("channel_code", query.channel_code);
  }

  /**
   * 直接重定向到贷超
   * 1.带ismarket标识
   * 2.带token
   * 3.不是注册页
   */
  if (
    query.ismarket &&
    query.token &&
    to.name !== "regist" &&
    to.name !== "list"
  ) {
    next("/list");
  } else {
    next();
  }

  // next();
});
export default router;
